import { Routes } from '@angular/router';

import { ToggleGuard } from '@ecm/router';

/**
 * Routes aliases to proxify root paths to real Features paths
 * This pattern may improve SEO
 */
export const AliasesRoutes: Routes = [
    {
        path: 'activer-sim',
        redirectTo: 'equipements/activer-sim',
    },
    {
        path: 'cession-de-ligne',
        redirectTo: 'contrat/cession-de-ligne',
    },
    {
        path: 'documents',
        redirectTo: 'contrat/documents',
    },
    {
        path: 'changer-votre-numero-mobile',
        redirectTo: 'equipements/changer-votre-numero-mobile',
    },
    {
        path: 'code-puk',
        redirectTo: 'equipements/code-puk',
    },
    {
        path: 'commander-carte-sim',
        redirectTo: 'equipements/commander-carte-sim',
    },
    {
        path: 'votre-mobile-perdu-ou-vole',
        redirectTo: 'equipements/votre-mobile-perdu-ou-vole',
    },
    {
        path: 'mobile-casse-ou-oxyde',
        redirectTo: 'equipements/mobile-casse-ou-oxyde',
    },
    {
        path: 'etranger',
        redirectTo: 'offre-options/etranger',
    },
    {
        path: 'mode-de-paiement',
        redirectTo: 'facture-paiement/mode-de-paiement',
    },
    {
        path: 'consulter-ma-facture',
        redirectTo: 'facture-paiement/consulter-ma-facture',
    },
    {
        path: 'payer-ma-facture-en-ligne',
        redirectTo: 'facture-paiement/payer-ma-facture-en-ligne',
    },
    {
        path: 'rdv-boutique',
        redirectTo: 'rdv/creation',
    },
    {
        path: 'rdv/rdv-boutique',
        redirectTo: 'rdv/creation',
    },
    {
        path: 'compte/rdv-boutique',
        redirectTo: 'rdv/creation',
    },
    {
        path: 'rdv-gestion',
        redirectTo: 'rdv/rdv-gestion',
    },
    {
        path: 'tarifs-international',
        redirectTo: 'offre-options/tarifs-international',
    },
    {
        path: 'verification-moyens-contact',
        redirectTo: 'compte/verification-moyens-contact',
    },
    {
        path: 'resilier-mon-option',
        redirectTo: 'offre-options/resilier-mon-option',
    },
    {
        path: 'changer-de-nom-prenom-civilite',
        redirectTo: 'compte/changer-de-nom-prenom-civilite',
    },
    {
        path: 'reprise-offre-deces',
        redirectTo: 'contrat/reprise-resiliation-offre-deces',
    },
    {
        path: 'reprise-resiliation-offre-deces',
        redirectTo: 'contrat/reprise-resiliation-offre-deces',
    },
    {
        path: 'resilier-mon-contrat',
        redirectTo: 'contrat/resilier-mon-contrat',
    },
    {
        path: 'deposer-une-reclamation',
        redirectTo: 'contrat/deposer-une-reclamation',
    },
    {
        path: 'procuration',
        redirectTo: 'compte/procuration',
    },
    {
        path: 'renvoi-appel',
        redirectTo: 'equipements/renvoi-appel',
    },
    {
        path: 'services-telephoniques-fixe',
        redirectTo: 'equipements/services-telephoniques-fixe',
    },
    {
        path: 'code-tv',
        redirectTo: 'equipements/code-tv',
    },
    {
        path: 'antispam-appels',
        redirectTo: 'equipements/antispam-appels',
    },
    {
        path: 'identification-prepayes',
        redirectTo: 'equipements/identification-prepayes',
    },
];

/**
 * All routes of Lazy Loaded Modules
 * Shared between ecm-app and ecm-eclair
 */
export const LazyRoutes = [
    {
        path: 'commandes',
        loadChildren: () => import('@ecm/commandes').then((m) => m.EcmCommandesModule),
        canActivate: [ToggleGuard],
        data: {
            toggle: 'COMMANDES.ORDERS_IS_ACTIVATED',
        },
    },
    {
        path: 'compte',
        loadChildren: () => import('@ecm/compte').then((m) => m.EcmCompteModule),
    },
    {
        path: 'conso',
        loadChildren: () => import('@ecm/conso').then((m) => m.EcmConsoModule),
    },
    {
        path: 'contrat',
        loadChildren: () => import('@ecm/contrat').then((m) => m.EcmContratModule),
    },
    {
        path: 'equipements',
        loadChildren: () => import('@ecm/equipement').then((m) => m.EcmEquipementModule),
    },
    {
        path: 'facture-paiement',
        loadChildren: () => import('@ecm/facture-paiement').then((m) => m.EcmFacturePaiementModule),
    },
    {
        path: 'offre-options',
        loadChildren: () => import('@ecm/offre-options').then((m) => m.EcmOffreOptionsModule),
    },
    {
        path: 'rdv',
        loadChildren: () => import('@ecm/rendez-vous').then((m) => m.EcmRendezVousModule),
    },
    {
        path: 'usage',
        loadChildren: () => import('@ecm/usage').then((m) => m.EcmUsageModule),
    },
    {
        path: 'acces-restreint',
        loadChildren: () => import('@ecm/restricted-access').then((m) => m.RestrictedAccessModule),
    },
    {
        path: 'avantages',
        loadChildren: () => import('@ecm/advantages').then((m) => m.AdvantagesModule),
    },
    {
        path: 'tout-votre-espace-client',
        loadChildren: () => import('@ecm/ecm-sitemap').then((m) => m.EcmSitemapModule),
    },
];
